import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/hide-layout-component.schema.json';
import setLayoutProperty from './setLayoutProperty';

const mapHideLayoutComponent = action => ({
  type: 'setLayoutProperty',
  data: {
    path: `components.${action.data}.properties.visible`,
    value: false,
  },
});

const hideLayoutComponent = (context, event, meta) => {
  const validated = makeValidated(schema);
  return setLayoutProperty(context, event, {
    action: mapHideLayoutComponent(
      validated(interpolate(meta.action, event, context))
    ),
  });
};

export default hideLayoutComponent;
